import { restAPI } from '../rest-api';

import { decryptionWorker } from '~/hooks/cryptography/decryptText';

const endpoints = restAPI.injectEndpoints({
  endpoints: (builder) => ({
    decryptText: builder.query<string, { content: string }>({
      async queryFn({ content }) {
        try {
          const result = await decryptionWorker.decryptText(content);
          return { data: result };
        } catch {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: 'Error in decrypting text',
            },
          };
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const UtilityService = endpoints;
